<div class="flex flex-col">
  <div class="flex flex-row">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
              'bg-gray-600': sharedService.userTheme === 'dark',
              'bg-indigo-50': sharedService.userTheme === 'light'}">
      <div class="flex flex-row items-center">
        <div class="flex flex-row w-full">
          <div>
            <span style="font-weight:bold;">Records: </span>
            <span>{{list.length}}</span>
          </div>
        </div>

        <div class="flex flex-row">
          <button mat-icon-button matTooltip="Print License"
            (click)="print()" [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">printer</mat-icon>
          </button>
          <button mat-icon-button *ngIf="editMode == 'list' && !labService.readonly" matTooltip="Add New" (click)="addNewLicense()"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">add</mat-icon>
          </button>
          <button mat-icon-button *ngIf="editMode !== 'list' && !labService.readonly" matTooltip="Save" (click)="saveLicenseCash()"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">save</mat-icon>
          </button>
          <button mat-icon-button *ngIf="editMode !== 'list'" matTooltip="Cancel" (click)="cancel()"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">cancel</mat-icon>
          </button>
        </div>
      </div>
    </mat-card>
  </div>

    <div class="flex flex-row" *ngIf="editMode == 'list'">
      <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
      'bg-gray-700': sharedService.userTheme === 'dark',
      'bg-indigo-50': sharedService.userTheme === 'light'}">
        <mat-card-content>
          <div class="flex flex-col" *ngIf="list.length !== 0">
            <div class="flex flex-row">
              <mat-form-field class="flex-1 min-w-[30%] sm:min-w-full">
                <input matInput id="listFilter" (keyup)="filterTable($event)" placeholder="Filter"
                  value="{{listFilter}}" />

                <button *ngIf="listFilter" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div style="overflow-x:auto">
              <div class="flex flex-row">
                <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort 
                  #TableSort="matSort" class="mat-elevation-z8 w-full" matSortActive="licExpire" matSortDirection="desc">
                  <ng-container matColumnDef="licDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Licensed</th>
                    <td mat-cell *matCellDef="let change">{{change.licDate}}</td>
                  </ng-container>
                  <ng-container matColumnDef="licExpire">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Expiration Date</th>
                    <td mat-cell *matCellDef="let change">{{change.licExpire}}</td>
                  </ng-container>
                  <ng-container matColumnDef="cashDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Cash Date</th>
                    <td mat-cell *matCellDef="let change">{{change.cashDate}}</td>
                  </ng-container>
                  <ng-container matColumnDef="crNum">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Credit Number</th>
                    <td mat-cell *matCellDef="let change">{{change.crNum}}</td>
                  </ng-container>
                  <ng-container matColumnDef="cert">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Certification Number</th>
                    <td mat-cell *matCellDef="let change">{{change.cert}}</td>
                  </ng-container>
                  <ng-container matColumnDef="amtPd">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount Paid</th>
                    <td mat-cell *matCellDef="let change">{{change.amtPd}}</td>
                  </ng-container>
                  <ng-container matColumnDef="credit">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Credit</th>
                    <td mat-cell *matCellDef="let change">{{change.credit}}</td>
                  </ng-container>
                  <ng-container matColumnDef="licashId">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Actions</th>
                    <td mat-cell *matCellDef="let row">
                      <button mat-icon-button *ngIf="!labService.readonly" matTooltip="Edit" (click)="editLicenseCash(row)"
                        [matTooltipShowDelay]="750">
                        <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">edit</mat-icon>
                      </button>
                      <button mat-icon-button *ngIf="!labService.readonly" matTooltip="Delete" (click)="deleteLicenseCash(row.licashId)"
                        [matTooltipShowDelay]="750">
                        <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''" class="text-red-500">delete
                        </mat-icon>
                      </button>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
              </div>
            </div>
            <mat-paginator [pageSizeOptions]="getPageSizeOptions()" #TablePaginator="matPaginator" showFirstLastButtons>
            </mat-paginator>
          </div>

        </mat-card-content>

      </mat-card>
    </div>
  <form [formGroup]="licenseFormGroup">
    <div class="flex flex-col" *ngIf="editMode != 'list'">
      <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
              'bg-gray-600': sharedService.userTheme === 'dark',
              'bg-indigo-50': sharedService.userTheme === 'light'}">
        <div class="flex flex-col">

          <div class="flex flex-row gap-4">
            <div class="flex flex-row flex-wrap w-1/2 sm:flex-col">
              <mat-card-content class="w-full">
                <div class="flex flex-col mt-4 w-full">

                  <mat-form-field>
                    <mat-label>Date Licensed</mat-label>
                    <input matInput [matDatepicker]="licDate" formControlName="licDate">
                    <mat-datepicker-toggle matSuffix [for]="licDate"></mat-datepicker-toggle>
                    <mat-datepicker #licDate></mat-datepicker>
                    <mat-error *ngIf="licenseFormGroup.get('licDate').invalid">
                      Invalid Date.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Cash Date</mat-label>
                    <input matInput [matDatepicker]="cashDate" formControlName="cashDate">
                    <mat-datepicker-toggle matSuffix [for]="cashDate"></mat-datepicker-toggle>
                    <mat-datepicker #cashDate></mat-datepicker>
                    <mat-error *ngIf="licenseFormGroup.get('cashDate').invalid">
                      Invalid Date.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Cert Number</mat-label>
                    <input matInput formControlName="cert">
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Credit</mat-label>
                    <input matInput formControlName="credit">
                    <mat-error *ngIf="licenseFormGroup.get('credit').invalid">

                    </mat-error>
                  </mat-form-field>

                </div>
              </mat-card-content>
            </div>
            <div class="flex flex-row flex-wrap w-1/2 sm:flex-col">
              <mat-card-content class="w-full gap-4">
                <div class="flex flex-col mt-4">

                  <mat-form-field *ngIf="editMode == 'add'">
                    <mat-label>Expiration Date</mat-label>
                    <input matInput [matDatepicker]="licExpire" formControlName="licExpire">
                    <mat-datepicker-toggle matSuffix [for]="licExpire"></mat-datepicker-toggle>
                    <mat-datepicker #licExpire></mat-datepicker>
                    <mat-error *ngIf="licenseFormGroup.get('licExpire').invalid">
                      Invalid Date.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field  *ngIf="editMode == 'edit'">
                    <mat-label>Expiration Date</mat-label>
                    <input matInput formControlName="licExpire">
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Credit Number</mat-label>
                    <input matInput formControlName="crNum">
                    <mat-error *ngIf="licenseFormGroup.get('crNum').invalid">
                      Cannot be longer than 20 characters.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Amount Paid</mat-label>
                    <input matInput formControlName="amtPd">
                    <mat-error *ngIf="licenseFormGroup.get('amtPd').invalid">
                      Invalid amount
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Lab Fee</mat-label>
                    <mat-select formControlName="labFee">
                      <mat-option value=null disabled selected>Select</mat-option>
                      <mat-option value=50>$50</mat-option>
                      <mat-option value=150>$150</mat-option>
                    </mat-select>
                    <mat-error *ngIf="licenseFormGroup.get('labFee').invalid">
                      Invalid Fee.
                    </mat-error>
                  </mat-form-field>

                </div>
              </mat-card-content>
            </div>
          </div>

          <div class="flex flex-row gap-6 my-8" style="font-size:medium">
            <mat-card-content class="w-full gap-4">
              <div class="flex flex-col mt-4">
                <mat-form-field>
                  <mat-label>Comments</mat-label>
                  <textarea matInput cdkTextareaAutosize formControlName="comments"></textarea>
                  <mat-error *ngIf="licenseFormGroup.get('comments').invalid">
                    Cannot be longer than 4000 characters.
                  </mat-error>
                </mat-form-field>
              </div>
            </mat-card-content>
          </div>

        </div>
      </mat-card>

    </div>
  </form>

</div>
